(function () {
  'use strict';

  var minimumOptionCount = 16;
  var initiallyVisibleCount = 10;
  var selector = [
    '.product-section .variant-input-wrap[data-handle="colour"]',
    '.product-section .variant-input-wrap[data-handle="color"]'
  ].join(', ');

  function getOptions(fieldset) {
    return Array.prototype.slice.call(
      fieldset.querySelectorAll(':scope > .variant-input')
    );
  }

  function updateVisibleOptions(fieldset) {
    var options = getOptions(fieldset);

    options.forEach(function (option, index) {
      var input = option.querySelector('input[type="radio"]');
      var shouldRemainVisible = index < initiallyVisibleCount || (input && input.checked);

      option.classList.toggle('is-hidden-by-collapse', !shouldRemainVisible);
    });
  }

  function setExpanded(fieldset, button, expanded) {
    fieldset.classList.toggle('is-collapsed', !expanded);
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded
      ? 'Show fewer colours'
      : 'View all ' + getOptions(fieldset).length + ' colours';

    if (!expanded) {
      updateVisibleOptions(fieldset);
    }
  }

  function initialiseFieldset(fieldset, index) {
    if (fieldset.dataset.colourCollapseInitialised === 'true') {
      return;
    }

    var options = getOptions(fieldset);

    if (options.length < minimumOptionCount) {
      return;
    }

    fieldset.dataset.colourCollapseInitialised = 'true';
    fieldset.classList.add('colour-selector-collapse');

    if (!fieldset.id) {
      fieldset.id = 'ColourSelectorCollapse-' + index;
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'colour-selector-collapse__toggle';
    button.setAttribute('aria-controls', fieldset.id);

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      setExpanded(fieldset, button, !expanded);
    });

    fieldset.addEventListener('change', function () {
      if (button.getAttribute('aria-expanded') === 'false') {
        updateVisibleOptions(fieldset);
      }
    });

    fieldset.insertAdjacentElement('afterend', button);
    setExpanded(fieldset, button, false);
  }

  function initialiseColourSelectors(container) {
    var root = container || document;
    var fieldsets = root.matches && root.matches(selector)
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll(selector));

    fieldsets.forEach(initialiseFieldset);
  }

  document.addEventListener('page:loaded', function () {
    initialiseColourSelectors(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialiseColourSelectors(event.target);
  });

  document.addEventListener('variant:change', function () {
    document.querySelectorAll(selector).forEach(function (fieldset) {
      var button = fieldset.nextElementSibling;

      if (
        button &&
        button.classList.contains('colour-selector-collapse__toggle') &&
        button.getAttribute('aria-expanded') === 'false'
      ) {
        updateVisibleOptions(fieldset);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseColourSelectors(document);
    });
  } else {
    initialiseColourSelectors(document);
  }
})();